import React, { useEffect } from 'react';
import { getTenantAssetsDir } from '../../utils';


/**
 *
 * @returns {JSX.Element}
 */
// eslint-disable-next-line max-lines-per-function
const EHersEnrollmentStep3 = () => {
  const {
    hostId,
    logoHostAssetName,
  } = window.SE_CLIENT_CONFIG;

  const hostDomain = window.SE_HOST_DOMAIN;
  const assetsHostsDir = getTenantAssetsDir(hostDomain, hostId);

  // on mount, scroll to top
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12 col-xs-12">
            <div className="top-logo">
              <img src={`${assetsHostsDir}/${logoHostAssetName}`} alt="logo" className="top-logo-img" />
            </div>
            <div id="enrollment-complete-container">
              <h1>Thank you for enrolling in our program.</h1>
              <h2>Please allow 1-2 billing cycles to receive your eHERS report.</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EHersEnrollmentStep3;
